import { render } from "./CodeVerificationDialogContent.vue?vue&type=template&id=dcdcb612&scoped=true"
import script from "./CodeVerificationDialogContent.vue?vue&type=script&lang=js"
export * from "./CodeVerificationDialogContent.vue?vue&type=script&lang=js"

import "./CodeVerificationDialogContent.vue?vue&type=style&index=0&id=dcdcb612&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcdcb612"]])

export default __exports__